module.exports = __webpack_public_path__ + "img/icon-check-circle-orange.a1322a9c.svg";